import React, { ReactElement } from 'react';

import { BUTTON_TYPES, EvButton, EvTableColumn } from '@evinced-private/ui-common';

import { NAME_NOT_PROVIDED } from 'src/apps/dashboard/constants/Dashboard';
import { MobileRun } from 'src/apps/dashboard/types/MobileRunsTableTypes';
import { renderNumberCellFormatter } from 'src/common/components/ev-table/cell-formatters/numberCellFormatter';
import { formatShortMonthDatetime } from 'src/common/helpers/DateFormatHelper';

import { MOBILE_RUNS_TABLE_LABELS } from './MobileRunsTable.labels';

const handleViewDetails = (url?: string): void => {
	if (!url) {
		return;
	}
	window.open(url, '_blank');
};

const actionFormatter = (_cell: unknown, row: MobileRun): ReactElement => (
	<EvButton
		onClick={() => handleViewDetails(row.detailsUrl)}
		ariaLabel={MOBILE_RUNS_TABLE_LABELS.viewDetailsAria(row.name)}
		type={BUTTON_TYPES.GHOST}
		disabled={!row.detailsUrl}
		small
	>
		{MOBILE_RUNS_TABLE_LABELS.VIEW_DETAILS}
	</EvButton>
);

export const getMobileRunsColumns = (nameLabel: string): EvTableColumn[] => [
	{
		dataField: 'name',
		text: nameLabel,
		style: { width: '270px' },
		headerStyle: { width: '270px' },
		sort: true,
		formatter: (name: string) => name || NAME_NOT_PROVIDED
	},
	{
		dataField: 'criticalIssues',
		text: MOBILE_RUNS_TABLE_LABELS.CRITICAL_ISSUES,
		style: { width: '100px' },
		headerStyle: { width: '100px' },
		sort: true,
		formatter: renderNumberCellFormatter
	},
	{
		dataField: 'totalIssues',
		text: MOBILE_RUNS_TABLE_LABELS.TOTAL_ISSUES,
		style: { width: '90px' },
		headerStyle: { width: '90px' },
		sort: true,
		formatter: renderNumberCellFormatter
	},
	{
		dataField: 'date',
		text: MOBILE_RUNS_TABLE_LABELS.DATE,
		style: { width: '90px' },
		headerStyle: { width: '90px' },
		sort: true,
		formatter: (cell: string): string => (cell ? formatShortMonthDatetime(cell) : '')
	},
	{
		dataField: 'actions',
		text: MOBILE_RUNS_TABLE_LABELS.ACTIONS,
		style: { width: '120px' },
		headerStyle: { width: '120px' },
		formatter: actionFormatter
	}
];
